import React, { Component } from 'react';
import styled from 'styled-components'
import {Helmet} from 'react-helmet'

import PageWrapper from 'shared/PageWrapper'
import Flex from 'shared/Flex'
import FlexItem from 'shared/FlexItem'
import Div from 'shared/Div'
import GridWrapper from 'shared/GridWrapper'
import A from 'shared/A'
import Img from 'shared/Img'
import Stockists from 'components/Stockists'
import SmallHeader from 'shared/SmallHeader'

const Test = styled.h3`
  letter-spacing: .5px;
  transform: scaleY(.8);
  // &:hover {
  //   transform: scaleY(1.6);
  // }
  // transition: all .5s;
`
class Info extends Component {

  // renderStockists = (stockists) => {
  //   return (
  //     <Stockists>
  //         <Flex zIndex="8" style={{marginLeft: this.props.small ? 0 : 12}} mobile="flex-flow: column nowrap; align-items: flex-start; justify-content: flex-end;" wrap="true" center>
  //
  //           {
  //             stockists.map(continent => (
  //               <Flex key={continent.continent} mobile="flex-flow: column nowrap; align-items: flex-start; justify-content: flex-end;" center wrap="true" marginBottom="20px">
  //                 <SmallHeader>{continent.continent}</SmallHeader>
  //                 <Flex wrap="true" center mobile="flex-flow: column nowrap; align-items: flex-start;">
  //                   {
  //                     continent.stockists.map((stockist,i) => (
  //                       <A key={stockist.name+"_"+i} underline="true" marginBottom="5px" target="_blank" href={stockist.address}>{`${stockist.name} ${stockist.city}`}</A>
  //                     ))
  //                   }
  //                 </Flex>
  //               </Flex>
  //             ))
  //           }
  //
  //         </Flex>
  //       </Stockists>
  //   )
  // }

  render() {
    // const stockists = [
    //   {
    //     continent: "ONLINE",
    //     stockists: [
    //       {
    //         name: 'Opening Ceremony',
    //         city: '',
    //         address: 'https://www.openingceremony.com/'
    //       }
    //     ]
    //   },
    //   {
    //     continent: "NORTH AMERICA",
    //     stockists: [
    //       {
    //         name: 'Opening Ceremony,',
    //         city: 'NEW YORK',
    //         address: 'https://www.openingceremony.com/'
    //       },
    //       {
    //         name: 'Opening Ceremony,',
    //         city: 'LOS ANGELES',
    //         address: 'https://www.openingceremony.com/'
    //       },
    //       {
    //         name: 'Maimoun Store,',
    //         city: 'NEW YORK',
    //         address: 'https://maimounstore.com/'
    //       },
    //       {
    //         name: 'Soop Soop,',
    //         city: 'TORONTO',
    //         address: 'https://www.soopsoop.ca/'
    //       }
    //     ]
    //   },
    //   {
    //     continent: "EUROPE",
    //     stockists: [
    //       {
    //         name: 'L\'Insane,',
    //         city: 'PARIS',
    //         address: 'https://www.l-insane.com'
    //       },
    //       {
    //         name: 'Elevastor,',
    //         city: 'PARIS',
    //         address: 'https://elevastor.com/'
    //       },
    //       {
    //         name: 'LaBoutik,',
    //         city: 'LONDON',
    //         address: 'https://www.laboutik.com/'
    //       }
    //     ]
    //   },
    //   {
    //     continent: "ASIA",
    //     stockists: [
    //       {
    //         name: 'The Four-Eyed,',
    //         city: 'TOKYO',
    //         address: 'http://thefoureyed.net/'
    //       },
    //       {
    //         name: 'CYTOKININ,',
    //         city: 'SEOUL',
    //         address: 'http://shop2.drinkscancode.cafe24.com/shopinfo/company.html'
    //       },
    //       {
    //         name: 'Opening Ceremony,',
    //         city: 'TOKYO',
    //         address: 'https://www.openingceremonyjapan.com/'
    //       },
    //       {
    //         name: 'IHANSTYLE,',
    //         city: 'SEOUL',
    //         address: 'http://shop.ihanstyle.com'
    //       }
    //     ]
    //   },
    //   {
    //     continent: "OCEANIA",
    //     stockists: [
    //       {
    //         name: 'DISTAL PHALANX,',
    //         city: 'SYDNEY',
    //         address: 'https://www.distalphalanx.com/'
    //       },
    //       {
    //         name: 'TERMINAL SIX,',
    //         city: 'SYDNEY',
    //         address: 'https://www.terminalsixstore.com/'
    //       }
    //     ]
    //   }
    // ]
    return (
      <GridWrapper >
        <Helmet title="Barragán" />
        <br />
        <Flex column position="relative" smPosition="relative" name="nav" extraStyles={'height: calc(100vh - 70px); justify-content: center;'} mobile={'grid-column: 1 / span 2; text-align: center;'} >
          <Div zIndex="12" margin="50px 0 0 0" mobile="margin-top: 30px;">
            <Div zIndex="12" marginBottom="20px">
              <SmallHeader>ALL INQUIRIES + CUSTOMER SERVICE</SmallHeader>
              <A underline="true" href="mailto:info@barragannnn.com" target="_blank">info@barragannnn.com</A>
            </Div>
            <Div zIndex="12" marginBottom="20px">
              <SmallHeader>PR</SmallHeader>
              <A underline="true" href="mailto:pr@barragannnn.com" target="_blank">pr@barragannnn.com</A>
            </Div>
            <Div style={{height: '60px', width: '100%'}}>
            </Div>
            <Div zIndex="12" marginBottom="20px" mobile={'max-width: 250px; margin: 0 auto;'}>
              <SmallHeader>Our general hours of operation are Monday through Friday from 10AM - 6PM EST</SmallHeader>
            </Div>
            <Div zIndex="12" marginBottom="20px" mobile={'max-width: 250px; margin: 0 auto;'}>
              <SmallHeader>We are a small team and aim to respond to inquiries within 2 business days. </SmallHeader>
            </Div>

            {
              // this.props.small && this.renderStockists(stockists)
            }

        </Div>

        {
          // !this.props.small && this.renderStockists(stockists)
        }




        </Flex>
      </GridWrapper>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/containers/Info.js